// A person's first or last name as it is saved and shown: no spaces around
// it or doubled inside ("morgana " -> "Morgana", so "Thanks, Morgana." has no
// space before the period), and a capital at the start of each word when the
// person typed the word all in lower or all in upper case ("maria jose" ->
// "Maria Jose", "O'BRIEN" -> "O'Brien", "garcia-lopez" -> "Garcia-Lopez").
// A word typed in mixed case stays as written ("McDonald", "DeAndre"), and
// surname particles stay in lower case before the rest of the surname ("de
// la cruz" -> "de la Cruz", "van der berg" -> "van der Berg"); alone they are
// the surname ("le" -> "Le", "do" -> "Do"), and they don't open a first name.

const PARTICLES = new Set(["de", "del", "della", "la", "las", "los", "le", "da", "das", "do", "dos", "di", "du", "van", "von", "der", "den", "ten", "ter", "y", "e"]);
const ROMAN = /^(?:II|III|IV|VI|VII|VIII|IX)$/;

const isLower = (w) => w === w.toLowerCase() && w !== w.toUpperCase();
const isUpper = (w) => w === w.toUpperCase() && w !== w.toLowerCase();

const capitalized = (word) => word
  .toLowerCase()
  .split(/(['’-])/)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join("");

const fixWord = (word, index, words, isFirstName) => {
  if (ROMAN.test(word)) {
    return word;
  }
  const lower = word.toLowerCase();
  if (PARTICLES.has(lower) && index < words.length - 1 && !(isFirstName && index === 0) && (isLower(word) || isUpper(word))) {
    return lower;
  }
  return isLower(word) || isUpper(word) ? capitalized(word) : word;
};

// { firstName: true } for a first name (a particle there is a name: "Del").
export const personName = (value, { firstName = false } = {}) => String(value == null ? "" : value)
  .trim()
  .split(/\s+/)
  .filter(Boolean)
  .map((word, index, words) => fixWord(word, index, words, firstName))
  .join(" ");

// "First Last", each part cleaned.
export const fullName = (first, last) => [personName(first, { firstName: true }), personName(last)].filter(Boolean).join(" ");

export default personName;
